import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  AfterViewInit
} from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import { ExportExcelService } from 'app/service/export-excel.service'
import { ExportPPTService } from 'app/service/export-ppt.service'
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-market-performance',
  templateUrl: './market-performance.component.html',
  styleUrls: ['./market-performance.component.scss']
})
export class MarketPerformanceComponent implements OnInit, OnDestroy, AfterViewInit {
  radioMarketP
  dataChart
  chart
  inputStr: string
  strName
  form: FormGroup
  listMarketP
  getPrint
  year
  indexName = ['SET', 'SET50', 'mai']
  listTable = []
  list
  ytdValue = 0
  pdfChart: PdfChart = new PdfChart()
  dataProviderYTD: Array<Object>
  tradingDate
  listYTNY

  @Output() param = new EventEmitter()
  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private pptService: ExportPPTService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { ytdValue } = this.activatedRoute.snapshot.params
    const { pdf } = this.activatedRoute.snapshot.data
    const { print } = this.activatedRoute.snapshot.data
    this.pdfChart.setPdf(pdf)
    this.ytdValue = ytdValue === undefined ? 0 : Number(ytdValue)

    this.getPrint = print;

    this.radioMarketP = [
      { value: 0, des: 'YTD' },
      { value: 1, des: 'YTD with last year' },
      { value: 2, des: 'YTD with 2 years' },
      { value: 3, des: 'YTD with 3 years' },
      { value: 4, des: 'YTD with 4 years' }
    ]

    this.form = new FormGroup({
      ytdValue: new FormControl(this.ytdValue)
    })

    this.getLastTradingDate().then(endYear => {
      this.year = endYear
      this.markData(this.form.get('ytdValue').value)
    })
  }

  async markData(year) {
    await this.cpmService
      .getMarketPerformance(year, this.indexName)
      .then(response => {
        this.listMarketP = response.filter(d => d.year === this.year)
        this.listYTNY = response;
      })

    this.cpmService
      .getMarketPeriod(this.indexName, this.year, this.year)
      .then(response => {
        this.dataProviderYTD = response
        year.toString() === '0'
          ? (this.dataChart = this.getProviderByYTD())
          : (this.dataChart = this.markChart())

        this.chart = this.amCharts.makeChart(
          'marketPerformanceChartdiv',
          this.dataChart
        )
      })
  }

  onChangeData() {
    this.dataChart = []
    if (this.chart != null) {
      this.amCharts.destroyChart(this.chart)
    }
    this.ytdValue = this.form.get('ytdValue').value
    this.markData(this.form.get('ytdValue').value)
  }

  ngOnDestroy() {
    if (this.chart && this.chart.legend && this.chart.legend.destroy) {
      const tmp =
        this.chart != null ? this.amCharts.destroyChart(this.chart) : null
    }
  }

  markChart() {
    const listDate = []
    this.listYTNY.map(obj => {
      listDate.push(obj.year)
    })
    const uniqDate = listDate.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])
    uniqDate.sort()
    const dataList = []
    const indexN = ['SET', 'mai', 'SET50']
    uniqDate.map(date => {
      let col1
      let col2
      let col3, col4, col5
      const list = this.listYTNY.filter(ser => ser.year === date)
      list.map(obj => {
        if (obj.indexName === indexN[0]) {
          col1 = obj.marketCap
          col3 = obj.indexClose
        }
        if (obj.indexName === indexN[1]) {
          col2 = obj.marketCap
          col4 = obj.indexClose
        }
        if (obj.indexName === indexN[2]) {
          col5 = obj.indexClose
        }
      })

      const dateStr =
        date.toString() === this.year.toString()
          // ? date.toString() + ' YTD'
          ? date.toString()
          : date.toString()

      dataList.push({
        date: dateStr,
        market1: col1,
        market2: col2,
        setIndex: col3,
        maiIndex: col4,
        set50Index: col5
      })
    })

    const dataChart = {
      type: 'serial',
      theme: 'light',
      precision: 2,
      fontFamily: 'browallia',
      fontSize: 16,
      valueAxes: [
        {
          id: 'v1',
          stackType: 'regular', // add for stackType
          title: 'Market cap (M.Baht)',
          position: 'right',
          autoGridCount: false
        },
        {
          id: 'v2',
          title: 'Index (Point)',
          gridAlpha: 0,
          position: 'left',
          autoGridCount: false
        }
      ],
      graphs: [
        {
          id: 'g3',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#b35900',
          type: 'smoothedLine',
          title: 'SET index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'setIndex',
          balloonText: '<b>SET index: [[value]]</b>'
        },
        {
          id: 'g4',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#0039e6',
          type: 'smoothedLine',
          title: 'mai index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'maiIndex',
          balloonText: '<b>mai index: [[value]]</b>'
        },
        {
          id: 'g5',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#101907',
          type: 'smoothedLine',
          title: 'SET50 index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'set50Index',
          balloonText: '<b>SET50 index: [[value]]</b>'
        },
        {
          id: 'g1',
          valueAxis: 'v1',
          lineColor: '#ffa400',
          fillColors: '#ffa400',
          fillAlphas: 1,
          type: 'column',
          title: 'SET market cap (Right)',
          valueField: 'market1',
          clustered: false,
          columnWidth: 0.2,
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value
            value = parseFloat(value)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return 'SET ' + value + ' M'
          }
        },
        {
          id: 'g2',
          valueAxis: 'v1',
          lineColor: '#5f6062',
          fillColors: '#5f6062',
          fillAlphas: 1,
          type: 'column',
          title: 'mai market cap (Right)',
          valueField: 'market2',
          clustered: false,
          columnWidth: 0.2,
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value
            value = parseFloat(value)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return 'mai ' + value + ' M'
          }
        }
      ],
      chartCursor: {
        pan: true,
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        valueLineAlpha: 0.2
      },
      categoryField: 'date',
      categoryAxis: {
        // dateFormats: [
        //   {
        //     period: 'fff',
        //     format: 'JJ:NN:SS'
        //   },
        //   {
        //     period: 'ss',
        //     format: 'JJ:NN:SS'
        //   },
        //   {
        //     period: 'mm',
        //     format: 'JJ:NN'
        //   },
        //   {
        //     period: 'hh',
        //     format: 'JJ:NN'
        //   },
        //   {
        //     period: 'DD',
        //     format: 'MMM DD'
        //   },
        //   {
        //     period: 'WW',
        //     format: 'MMM DD'
        //   },
        //   {
        //     period: 'MM',
        //     format: 'MMM YYYY'
        //   },
        //   {
        //     period: 'YYYY',
        //     format: 'MMM YYYY'
        //   }
        // ],
        parseDates: true,
        dashLength: 1,
        minorGridEnabled: true,
        minorGridAlpha: 0,
        gridAlpha: 0,
        equalSpacing: true // delete space in graph
      },
      legend: {
        useGraphSettings: true,
        position: 'bottom',
        align: 'center',
        maxColumns: 3,
        valueText: '',
        valueWidth: 120
      },
      balloon: {
        borderThickness: 1,
        shadowAlpha: 0
      },
      export: {
        enabled: false,
        menu: [
          {
            class: 'export-main',
            menu: [
              {
                format: 'PDF',
                fileName: 'Market performance',
                content: [{ image: 'reference', fit: [523.28, 769.89] }]
              }
            ]
          }
        ]
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: 'Market performance'
        }
      ],
      dataProvider: dataList
    }

    return dataChart
  }

  getProviderByYTD() {
    const listDate = []
    this.dataProviderYTD.map(obj => {
      listDate.push(obj['tradingDate'])
    })
    const uniqDate = listDate.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])
    const dataList = []
    const indexN = ['SET', 'mai', 'SET50']
    uniqDate.map(date => {
      let col1
      let col2
      let col3, col4, col5
      const list = this.dataProviderYTD.filter(
        ser => ser['tradingDate'] === date
      )
      list.map(obj => {
        if (obj['indexName'] === indexN[0]) {
          col1 = obj['marketCap']
          col3 = obj['indexClose']
        }
        if (obj['indexName'] === indexN[1]) {
          col2 = obj['marketCap']
          col4 = obj['indexClose']
        }
        if (obj['indexName'] === indexN[2]) {
          col5 = obj['indexClose']
        }
      })

      dataList.push({
        date: new Date(date),//.substr(0, 10),
        market1: col1,
        market2: col2,
        setIndex: col3,
        maiIndex: col4,
        set50Index: col5
      })

      document
        .getElementById('marketPerformanceChartdiv')
        .classList.add('chartFinished')
    })

    const dataChart = {
      type: 'serial',
      theme: 'light',
      dataDateFormat: 'YYYY-MM-DD',
      precision: 2,
      fontFamily: 'browallia',
      fontSize: 16,
      valueAxes: [
        {
          id: 'v1',
          stackType: 'regular', // add for stackType
          title: 'Market cap (M.Baht)',
          position: 'right',
          autoGridCount: false
        },
        {
          id: 'v2',
          title: 'Index (Point)',
          gridAlpha: 0,
          position: 'left',
          autoGridCount: false
        }
      ],
      graphs: [
        {
          id: 'g3',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#b35900',
          type: 'smoothedLine',
          title: 'SET index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'setIndex',
          balloonText: '<b>SET index: [[value]]</b>'
        },
        {
          id: 'g4',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#0039e6',
          type: 'smoothedLine',
          title: 'mai index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'maiIndex',
          balloonText: '<b>mai index: [[value]]</b>'
        },
        {
          id: 'g5',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#101907',
          type: 'smoothedLine',
          title: 'SET50 index (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'set50Index',
          balloonText: '<b>SET50 index: [[value]]</b>'
        },
        {
          id: 'g1',
          valueAxis: 'v1',
          lineColor: '#ffa400',
          fillColors: '#ffa400',
          fillAlphas: 1,
          type: 'column',
          title: 'SET market cap (Right)',
          valueField: 'market1',
          clustered: false,
          columnWidth: 0.5,
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value
            value = parseFloat(value)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return 'SET: ' + value + ' M'
          }
        },
        {
          id: 'g2',
          valueAxis: 'v1',
          lineColor: '#5f6062',
          fillColors: '#5f6062',
          fillAlphas: 1,
          type: 'column',
          title: 'mai market cap (Right)',
          valueField: 'market2',
          clustered: false,
          columnWidth: 0.5,
          balloonFunction: function (graphDataItem, graph) {
            let value = graphDataItem.values.value
            value = parseFloat(value)
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return 'mai: ' + value + ' M'
          }
        }
      ],
      chartCursor: {
        pan: true,
        valueLineEnabled: false, // true
        valueLineBalloonEnabled: false, // true
        cursorAlpha: 0.2,
        valueLineAlpha: 0.2,
        cursorColor: '#E8E8E8',
        color: '#000000'
      },
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'fff',
            format: 'JJ:NN:SS'
          },
          {
            period: 'ss',
            format: 'JJ:NN:SS'
          },
          {
            period: 'mm',
            format: 'JJ:NN'
          },
          {
            period: 'hh',
            format: 'JJ:NN'
          },
          {
            period: 'DD',
            format: 'MMM DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM YYYY'
          },
          {
            period: 'YYYY',
            format: 'MMM YYYY'
          }
        ],
        parseDates: true,
        dashLength: 1,
        minorGridEnabled: true,
        minorGridAlpha: 0,
        gridAlpha: 0,
        equalSpacing: true // delete space in graph
      },
      legend: {
        useGraphSettings: true,
        position: 'bottom',
        align: 'center',
        maxColumns: 3,
        valueText: '',
        valueWidth: 120
      },
      balloon: {
        borderThickness: 1,
        shadowAlpha: 0
      },

      export: {
        enabled: false,
        menu: [
          {
            class: 'export-main',
            menu: [
              {
                format: 'PDF',
                fileName: 'Market performance',
                content: [{ image: 'reference', fit: [523.28, 769.89] }]
              }
            ]
          }
        ]
      },
      titles: [
        {
          id: 'Title-1',
          text: 'Market performance',
          size: 20
        }
      ],
      dataProvider: dataList
    }
    return dataChart
  }

  Ppt() {
    this.pptService.pptMarketPerformance(
      this.listMarketP,
      this.dataChart,
      this.ytdValue
    )
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  exportExcel() {
    this.excelService.exportMarketPerformance(
      this.listMarketP,
      'Market performance'
    )
  }

  exportPdf() {
    const layout = { content: [] }
    layout.content.push({
      text: ' ',
      fontSize: 15
    })
    const images = []
    let pending = this.amCharts.charts.length

    for (let i = 0; i < this.amCharts.charts.length; i++) {
      const chart = this.amCharts.charts[i]
      chart.export.capture({}, function () {
        this.toJPG(
          {
            multiplier: 2
          },
          function (data) {
            images.push({
              image: data,
              fit: [523.28, 769.89]
            })
            pending = pending - 1
            if (pending === 0) {
              layout.content.push(images)
              // all done - construct PDF
              chart.export.toPDF(layout, function (dataToGeneratePdf) {
                this.download(
                  dataToGeneratePdf,
                  'application/pdf',
                  'amCharts.pdf'
                )
              })
            }
          }
        )
      })
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'indexNegative' : 'indexPositive'
  }

  numberWithCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-performance/market-performance.component.ts